module.exports = __webpack_public_path__ + "img/yrf.5c74a13b.jpg";